const deadlineChartHeaders = [
  { title: "deadiline_chart_headers.num", key: "num", align: "center" },
  { title: "deadiline_chart_headers.date", key: "date", value: "date.seconds", align: "center" },
  { title: "deadiline_chart_headers.plan", key: "plan", align: "center" },
  { title: "deadiline_chart_headers.fact", key: "fact", align: "center" },
];

const deadlineHeaders = [
  { title: "deadiline_chart_headers.num", align: "center", key: "num", sortable: false },
  { title: "deadiline_chart_headers.level1", align: "center", key: "lvl1name" },
  { title: "deadiline_chart_headers.level2", align: "center", key: "lvl2name" },
  { title: "deadiline_chart_headers.level3", align: "center", key: "lvl3name" },
  {
    title: "deadiline_chart_headers.ttc",
    align: "center",
    key: "ttkname",
  },
  {
    title: "deadiline_chart_headers.worker",
    align: "center",
    key: "controllername",
    sortable: false,
  },
  { title: "deadiline_chart_headers.date", align: "center", key: "date", sortable: false },
  { title: "deadiline_chart_headers.fact", align: "center", key: "fact", sortable: false },
];

export const qualityHeaders = [
  { title: "quality_headers.num", key: "num", align: "center" },
  { title: "quality_headers.contractor", key: "contractorname", align: "center" },
  { title: "quality_headers.status", key: "isfixed", align: "center" },
  { title: "quality_headers.deviation_date", key: "computedDate", align: "center", sortable: true },
  { title: "quality_headers.correction_date", key: "computedFixDate", align: "center", sortable: true },
  { title: "quality_headers.level1", key: "lvl1name" },
  { title: "quality_headers.level2", key: "lvl2name" },
  { title: "quality_headers.level3", key: "lvl3name" },
  { title: "quality_headers.level4", key: "lvl4name" },
  { title: "quality_headers.level5", key: "lvl5name" },
  { title: "quality_headers.ttc", key: "technologycardname", align: "center" },
  { title: "quality_headers.cause", key: "normativedocumentname", align: "center", sortable: false },
  { title: "quality_headers.comment", key: "note", align: "center", sortable: false },
  { title: "quality_headers.photo", key: "photofilepath", align: "center", sortable: false },
  { title: "quality_headers.scheme", key: "schemefilepath", align: "center", sortable: false },
];

export default {
  deadlineHeaders,
  deadlineChartHeaders,
  qualityHeaders,
};
